@if (header) {
  <h4 sbSurfaceTitle class="m-0" [innerHTML]="header"></h4>
}
<div class="flex flex-col gap-4 text-sm font-medium text-default">
  <ng-content></ng-content>
</div>
